import { connect } from "react-redux";
import Fees from "./Fees";
import { getStoreCode } from "../../../../state/modules/regionalStore";
import { getFeesPriceText } from "../../../../state/modules/bag";

const mapStateToProps = state => ({
  storeCode: getStoreCode(state),
  text: getFeesPriceText(state)
});

export default connect(mapStateToProps)(Fees);
